import { debounce } from 'lodash';
import { useEffect, useRef, useState } from 'react';

import { useAuth } from '@/common/contexts/AuthContext';

const SMALL_SIZE_LIMIT = 900;
const MEDIUM_SIZE_LIMIT = 1000;

const useTableRowSize = (isTableRow, outerContainerRef) => {
  const { isShowNetPrice } = useAuth();
  const isMountRef = useRef(true);
  const innerContainerRef = useRef(null);
  const containerRef =
    outerContainerRef === null ? innerContainerRef : outerContainerRef;
  const [size, setSize] = useState('large');

  useEffect(() => {
    const handleResize = () => {
      if (isMountRef.current) {
        let nextSize = 'large';
        if (containerRef.current) {
          const { width } = containerRef.current.getBoundingClientRect();
          const formattedWidth = width - (isShowNetPrice ? 110 : 0);
          if (formattedWidth < MEDIUM_SIZE_LIMIT) {
            nextSize = 'medium';
          }
          if (formattedWidth < SMALL_SIZE_LIMIT) {
            nextSize = 'small';
          }
        }
        setSize(nextSize);
      }
    };
    const handleResizeDebounced = debounce(handleResize, 250);
    const resizeObserver = new ResizeObserver(() => {
      handleResizeDebounced();
    });
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
      handleResize();
    }
    return () => {
      isMountRef.current = false;
      resizeObserver.disconnect();
    };
  }, [containerRef, isShowNetPrice]);

  return {
    containerRef,
    tableRowSize: isTableRow ? size : null,
  };
};

export default useTableRowSize;
